import { render, staticRenderFns } from "./horizontalTable.vue?vue&type=template&id=f6af75d2&"
import script from "./horizontalTable.vue.js?vue&type=script&lang=js&"
export * from "./horizontalTable.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports